const RECOMMEND_TYPE = {
  RECOMMENDATION_DAILY_HP: 11,
  RECOMMENDATION_OPTION_HP: 12,
  RECOMMENDATION_HP: 13,
  DAILY_RECOMMENDATION_HP: 14
};

export default RECOMMEND_TYPE;
